import { isClient } from '@vueuse/core'
import mobileDetect from 'ismobilejs'
import prettyBytes from 'pretty-bytes'

export const isMobile = isClient ? mobileDetect().any : false
export const formatBytes = prettyBytes

export function findTitleInArray(array: any[] | undefined) {
  return array?.find(item => item.key === 'title')?.value
}
